module.exports = "<div>\n  <label>\n    <input type='checkbox'\n    (click)='click()'\n    [checked]='currentState'\n    />\n    {{label}}\n  </label>\n\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /GIT/Search-manager/rating-module/src/app/tag-rating/tag-rating.component.html
// module id = ../../../../../src/app/tag-rating/tag-rating.component.html
// module chunks = main